import { PropsWithChildren, SyntheticEvent } from 'react';
import { A } from '@bridebook/ui';
import { Link } from '@bridebook/web/app-shared/components/link/link';
import componentStyles from './link-content-wrapper.style';

interface IProps extends PropsWithChildren {
  supplierUrl: string;
  onCustomClick?: (event: SyntheticEvent<any>) => any;
  dataTest?: string;
}

const LinkContentWrapper = ({ supplierUrl, onCustomClick, children, dataTest }: IProps) => {
  const styles = componentStyles();
  return (
    <Link href={supplierUrl} passHref legacyBehavior>
      <A onClick={onCustomClick} style={styles.linkStyle} noUnderline dataTest={dataTest}>
        {children}
      </A>
    </Link>
  );
};

export default LinkContentWrapper;
